import { IPaginatedResult, SmartsheetUser } from '../interfaces';
import { PaginatedResult } from './';

export class PaginatedUserResult extends PaginatedResult<SmartsheetUser> {
    public constructor(paginatedResult?: IPaginatedResult<SmartsheetUser>) {
        super(paginatedResult);
    }
}
